// Guest types in the order New Booking's Total Guests fills and empties them.
const GUEST_TYPE_ORDER = ["adults", "children", "infants", "passengers"]

// The price's flag allowing each guest type.
export const GUEST_ALLOWED_FLAGS = {
  adults: "adults_allowed",
  children: "children_allowed",
  infants: "infants_allowed",
  passengers: "passengers_allowed"
}

// The first guest type the price allows; it holds the booking's minimum guests.
export const getFirstAllowedGuestType = (tripPrice) =>
  GUEST_TYPE_ORDER.find((key) => !tripPrice || tripPrice[GUEST_ALLOWED_FLAGS[key]] !== false) ?? "adults"

export const sumGuestCounts = (counts) => GUEST_TYPE_ORDER.reduce((sum, key) => sum + (Number(counts?.[key]) || 0), 0)

/**
 * The guest counts after Total Guests moves to `total`: more guests go to the first type the price
 * allows; fewer are taken back last type first (passengers, infants, children), the first type
 * keeping at least one guest.
 *
 * @param {Object} counts - { adults, children, infants, passengers }
 * @param {number} total - the new Total Guests
 * @param {string} [firstGuestType] - the first guest type the price allows
 * @returns {Object} counts that add up to `total` (or as close as the first type's one guest allows)
 */
export const fitGuestCountsToTotal = (counts, total, firstGuestType = "adults") => {
  const fitted = Object.fromEntries(GUEST_TYPE_ORDER.map((key) => [key, Number(counts?.[key]) || 0]))
  let difference = total - sumGuestCounts(fitted)
  if (difference > 0) {
    fitted[firstGuestType] += difference
    return fitted
  }
  for (const key of [...GUEST_TYPE_ORDER].reverse()) {
    if (difference === 0) break
    const keep = key === firstGuestType ? 1 : 0
    const taken = Math.min(Math.max(0, fitted[key] - keep), -difference)
    fitted[key] -= taken
    difference += taken
  }
  return fitted
}
